import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

export const Countries = styled.ul`
    list-style-type: none;
    margin: 0 0 32px 0;
    padding: 0;

    & > li {
        margin: 0;
        padding: 0;
        white-space: nowrap;

        ${promoMedia.tablet744} {
            -webkit-column-break-inside: avoid;
            break-inside: avoid;
        }
    }

    ${promoMedia.tablet744} {
        column-count: 2;
        column-gap: 85px;
        margin: 0 0 48px 0;
    }

    ${promoMedia.desktop1440} {
        column-count: 3;
        column-gap: 80px;
        margin: 0 0 64px 0;
    }
`;
export const CountryName = styled.div``;
export const CountryLink = styled.a`
    display: flex;
    align-items: center;
    outline: none;
    padding-bottom: 8px;
    padding-top: 8px;
    text-decoration: none;

    &:link,
    &:visited {
        color: ${promoColors.gray40};
    }

    &:focus-visible {
        background-color: ${promoColors.gray5};
        outline: 1px dashed ${promoColors.gray40};

        ${CountryName} {
            color: ${promoColors.gray80};
        }
    }

    &:hover {
        ${CountryName} {
            color: ${promoColors.primary};
        }
    }
`;
export const FlagWrapper = styled.span`
    height: 24px;
    margin-right: 24px;
`;
